module.exports = __webpack_public_path__ + "static/media/logo.50817ff7.png";